module.exports = __webpack_public_path__ + "media/images/promo-booking-bde0afb37aa4a31e78bdd43100a1aebe.png";